'use client';
import { FC, ReactNode } from 'react';
import InfoTip from '../InfoTip';
import InfoFill from '../icons/Action/InfoFill';
import styles from './styles.module.scss';

const Tooltip: FC<{ message: ReactNode }> = ({ message }) => {
  return (
    <div className={styles.tooltip}>
      <InfoFill />
      <div className={styles.tooltiptext}>
        <InfoTip message={<p className="s">{message}</p>} />
      </div>
    </div>
  );
};

export default Tooltip;
